import React, { useState } from 'react';
import { Upload, Send, Image, AlertCircle, CheckCircle } from 'lucide-react';

const UploadImage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setError('Please select a valid image file');
        return;
      }
      
      setSelectedImage(file);
      setError(null);
      setResult(null);
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const getCookie = (name) => {
   return localStorage.getItem(name);
  };


const handleSendImage = async () => {
    if (!selectedImage) {
        setError('Please select an image first');
        return;
    }

    setIsLoading(true);
    setError(null);

    try {
        // Get docid from your existing logic
        const urlParams = new URLSearchParams(window.location.search);
        const currentDomain = urlParams.get("parentUrl");
        const data_var = currentDomain + "myData";
        const storedData = getCookie(data_var);
        const parsedData = JSON.parse(storedData);
        const docid = parsedData.key;

        // Prepare form data
        const formData = new FormData();
        formData.append('file', selectedImage);
        formData.append('docid', docid);
      // '919727972810'
         formData.append('recipientNumber','919727972810' ); // Optional: make this configurable
        formData.append('phoneNumberId', '657441400786999'); // Optional: make this configurable
        formData.append('message', 'Please analyze this skin tone image and select the appropriate category:');

        // Call your Azure Function
        const AZURE_FUNCTION_URL = 'https://krunkaifunctionapp1.azurewebsites.net/api/send_special_message';
        
        console.log('Sending image to WhatsApp via Azure Function...');
        
        const response = await fetch(AZURE_FUNCTION_URL, {
            method: 'POST',
            body: formData,
            // Don't set Content-Type header - let browser set it for FormData
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        
        if (result.success) {
            setResult({
                success: true,
                message: 'Image and interactive message sent to WhatsApp successfully!',
                data: result.data
            });
            
            console.log('WhatsApp messages sent successfully:', result.data);
            
            // Optional: Show success notification
        
            
        } else {
            throw new Error(result.error || 'Unknown error occurred');
        }

    } catch (err) {
        console.error('Error sending to WhatsApp:', err);
        setError(err.message || 'Failed to send messages to WhatsApp. Please try again.');
        
        // Optional: Show error notification
        showErrorNotification(err.message);
    } finally {
        setIsLoading(false);
    }
};

const checkMessageStatus = async (messageId) => {
    try {
        const response = await fetch(`https://your-function-app.azurewebsites.net/api/health`);
        const data = await response.json();
        console.log('Service health:', data);
        return data.status === 'healthy';
    } catch (error) {
        console.error('Health check failed:', error);
        return false;
    }
};

// Optional: Success/Error notification functions
const showSuccessNotification = (message) => {
    // You can integrate with your existing notification system
    // or use a simple alert for now
    alert(`✅ Success: `);
};

const showErrorNotification = (message) => {
    // You can integrate with your existing notification system
    // or use a simple alert for now
    alert(`❌ Error: ${message}`);
};
// const handleSendImage = async () => {
//   if (!selectedImage) return;

//   setIsLoading(true);
//   setError(null);

//   try {
//     const urlParams = new URLSearchParams(window.location.search);
//     const currentDomain = urlParams.get("parentUrl");
//     const data_var = currentDomain + "myData";
//     const storedData = getCookie(data_var);
//     const parsedData = JSON.parse(storedData);
//     const docid = parsedData.key;

//     // WhatsApp API configuration
//     const PHONE_NUMBER_ID = '657441400786999';
//     const BEARER_TOKEN = 'YOUR_BEARER_TOKEN'; // Replace with your actual token
//     const TO_NUMBER = '919727972810'; // Remove spaces and + for API
//     const WHATSAPP_API_URL = `https://graph.facebook.com/v18.0/${PHONE_NUMBER_ID}/messages`;

//     // Step 1: Upload image to WhatsApp Media API
//     const uploadImageToWhatsApp = async (imageFile) => {
//       const formData = new FormData();
//       formData.append('file', imageFile);
//       formData.append('type', imageFile.type);
//       formData.append('messaging_product', 'whatsapp');

//       const uploadResponse = await fetch(`https://graph.facebook.com/v18.0/${PHONE_NUMBER_ID}/media`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${BEARER_TOKEN}`,
//         },
//         body: formData,
//       });

//       if (!uploadResponse.ok) {
//         throw new Error(`Failed to upload image: ${uploadResponse.status}`);
//       }

//       const uploadData = await uploadResponse.json();
//       return uploadData.id; // Media ID
//     };

//     // Step 2: Send image message
//     const sendImageMessage = async (mediaId) => {
//       const imagePayload = {
//         messaging_product: 'whatsapp',
//         to: TO_NUMBER,
//         type: 'image',
//         image: {
//           id: mediaId,
//           caption: 'Please analyze this skin tone image and select the appropriate category:'
//         }
//       };

//       const imageResponse = await fetch(WHATSAPP_API_URL, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${BEARER_TOKEN}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(imagePayload),
//       });

//       if (!imageResponse.ok) {
//         throw new Error(`Failed to send image: ${imageResponse.status}`);
//       }

//       return await imageResponse.json();
//     };

//     // Step 3: Send interactive message with buttons
//     const sendInteractiveMessage = async () => {
//       const interactivePayload = {
//         messaging_product: 'whatsapp',
//         to: TO_NUMBER,
//         type: 'interactive',
//         interactive: {
//           type: 'button',
//           header: {
//             type: 'text',
//             text: 'Skin Tone Analysis'
//           },
//           body: {
//             text: 'Based on the image above, please select the most appropriate skin tone category:'
//           },
//           footer: {
//             text: 'Select one option'
//           },
//           action: {
//             buttons: [
//               {
//                 type: 'reply',
//                 reply: {
//                   id: `light_${docid}`,
//                   title: 'Light'
//                 }
//               },
//               {
//                 type: 'reply',
//                 reply: {
//                   id: `medium_${docid}`,
//                   title: 'Medium'
//                 }
//               },
//               {
//                 type: 'reply',
//                 reply: {
//                   id: `dark_${docid}`,
//                   title: 'Dark'
//                 }
//               }
//             ]
//           }
//         }
//       };

//       const interactiveResponse = await fetch(WHATSAPP_API_URL, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${BEARER_TOKEN}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(interactivePayload),
//       });

//       if (!interactiveResponse.ok) {
//         throw new Error(`Failed to send interactive message: ${interactiveResponse.status}`);
//       }

//       return await interactiveResponse.json();
//     };

//     // Execute the sequence
//     console.log('Uploading image to WhatsApp...');
//     const mediaId = await uploadImageToWhatsApp(selectedImage);
    
//     console.log('Sending image message...');
//     const imageResult = await sendImageMessage(mediaId);
    
//     console.log('Sending interactive message...');
//     const interactiveResult = await sendInteractiveMessage();
    
//     setResult({
//       success: true,
//       message: 'Image and interactive message sent successfully to WhatsApp',
//       imageMessageId: imageResult.messages[0].id,
//       interactiveMessageId: interactiveResult.messages[0].id
//     });

//   } catch (err) {
//     console.error('WhatsApp API Error:', err);
//     setError(err.message || 'Failed to send message to WhatsApp. Please try again.');
//   } finally {
//     setIsLoading(false);
//   }
// }
  // const handleSendImage = async () => {
  //   if (!selectedImage) return;

  //   setIsLoading(true);
  //   setError(null);

  //   try {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     const currentDomain = urlParams.get("parentUrl");
  //     const data_var = currentDomain + "myData";
  //     const storedData = getCookie(data_var);
  //     const parsedData = JSON.parse(storedData);
  //     const  docid = parsedData.key;
  //     const formData = new FormData();

  //     formData.append('file', selectedImage);
  //     formData.append('docid', docid);
  //     // const local_url="http://127.0.0.1:8080/analyze-skin-tone"
  //     const new_url="https://yaan-man.agreeableplant-c6fa5f15.centralindia.azurecontainerapps.io/analyze-skin-tone"
  //     const response = await fetch(new_url, {
  //       method: 'POST',
  //       body: formData,
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const data = await response.json();
  //     setResult(data);
  //   } catch (err) {
  //     setError(err.message || 'Failed to analyze skin tone. Please try again.');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleImageClick = () => {
    document.getElementById('image-upload').click();
  };

  return (
    <div className="krunk-w-4/5 krunk-mr-auto krunk-ml-[7px] krunk-mb-[0px] krunk-mt-[7px] krunk-p-6 krunk-bg-headercolor krunk-rounded-lg krunk-shadow-lg">
      {/* Header */}
      <div className="krunk-text-center krunk-mb-6">
        <p className=" krunk-text-[13px] krunk-text-bubbletext krunk-leading-relaxed">
          You can find your perfect makeup shade, using tool <a href="https://www.yaanman.in/pages/find-your-shade?utm_source=krunkai" className="krunk-text-blue-600 hover:krunk-text-blue-700 krunk-underline krunk-font-medium"> Click here</a> or can upload your selfie in natural light to help us find your perfect skin shade.
        </p>
      </div>

      {/* Hidden file input */}
      <input
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        className="krunk-hidden"
        id="image-upload"
      />

      {/* Upload Section - Only show when no image is selected */}
      {!imagePreview && (
        <div className="krunk-mb-4">
          <label className="krunk-block krunk-text-bubbletext krunk-text-[13px]  krunk-mb-2">
            Upload Your Photo
          </label>
          
          <div 
            className="krunk-border-2 krunk-border-dashed krunk-border-gray-300 krunk-rounded-lg krunk-p-4 krunk-text-center hover:krunk-border-blue-400 krunk-transition-colors krunk-cursor-pointer"
            onClick={handleImageClick}
          >
            <Upload className="krunk-mx-auto krunk-h-8 krunk-w-8 krunk-text-gray-400 krunk-mb-2" />
            <p className="krunk-text-gray-600 krunk-text-xs krunk-mb-1">
              Upload your selfie here
            </p>
            <p className="krunk-text-xs krunk-text-gray-500">
              PNG, JPG, JPEG up to 10MB
            </p>
          </div>
        </div>
      )}

      {/* Image Preview - Clickable to change image */}
      {imagePreview && (
        <div className="krunk-mb-4">
          <label className="krunk-block krunk-text-sm krunk-font-medium krunk-text-gray-700 krunk-mb-2">
            Selected Image (Click to change)
          </label>
          <div className="krunk-relative krunk-bg-gray-50 krunk-rounded-lg krunk-p-3">
            <img
              src={imagePreview}
              alt="Selected"
              className="krunk-max-w-full krunk-max-h-32 krunk-mx-auto krunk-rounded-lg krunk-shadow-md krunk-cursor-pointer hover:krunk-opacity-80 krunk-transition-opacity"
              onClick={handleImageClick}
            />
          </div>
        </div>
      )}

      {/* Send Button - Smaller size */}
      {selectedImage && (
        <div className="krunk-mb-2 krunk-flex krunk-justify-center">
          <button
            onClick={handleSendImage}
            disabled={isLoading}
            className="krunk-krunk-bg-headercolor   krunk-text-black krunk-font-medium krunk-py-2 krunk-px-4 krunk-rounded-lg krunk-flex krunk-items-center krunk-space-x-2 krunk-transition-colors krunk-text-sm"
          >
            {isLoading ? (
              <>
                <div className="krunk-animate-spin krunk-rounded-full krunk-h-3 krunk-w-3 krunk-border-b-2 krunk-border-white"></div>
                <span>Analyzing...</span>
              </>
            ) : (
              <>
                <Send className="krunk-h-3 krunk-w-3" />
                <span>Analyze</span>
              </>
            )}
          </button>
        </div>
      )}

      {/* Error Message */}
      {error && (
        <div className="krunk-mb-4 krunk-bg-red-50 krunk-border krunk-border-red-200 krunk-rounded-lg krunk-p-3">
          <div className="krunk-flex krunk-items-center">
            <AlertCircle className="krunk-h-4 krunk-w-4 krunk-text-red-500 krunk-mr-2" />
            <p className="krunk-text-red-700 krunk-text-sm">{error}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadImage;